import { Component, OnDestroy, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MarriottPmsMessagesIndicatorWidget, ProjectCMSWidgetType, LogService } from 'htv-lib'
import { BaseWidgetComponent } from '../base-widget/base-widget.component'
import { StateService } from '../../services/state.service'
import { MessageStateService } from '../../services/message-state.service'

@Component({
  selector: 'app-marriott-pms-messages-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './marriott-pms-messages-indicator.component.html',
  styleUrls: ['./marriott-pms-messages-indicator.component.scss'],
})
export class MarriottPmsMessagesIndicatorComponent extends BaseWidgetComponent implements OnInit, OnDestroy {
  unreadCount = 0

  constructor(
    private stateService: StateService,
    private messageStateService: MessageStateService,
    private logService: LogService
  ) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit()
    this.messageStateService.startPolling()
    this.loadUnreadCount()
    this.stateService.startShowingWidget(ProjectCMSWidgetType.MARRIOTT_PMS_MESSAGES_INDICATOR)
  }

  override ngOnDestroy(): void {
    this.messageStateService.stopPolling()
    this.stateService.stopShowingWidget(ProjectCMSWidgetType.MARRIOTT_PMS_MESSAGES_INDICATOR)
    super.ngOnDestroy()
  }

  loadUnreadCount(): void {
    this.subscriptions.add(
      this.messageStateService.unreadCount$.subscribe({
        next: count => {
          this.unreadCount = count
          this.logService.debug(`[MarriottPmsMessagesIndicatorComponent] Unread count: ${this.unreadCount}`)
        },
        error: err => {
          this.logService.error(`[MarriottPmsMessagesIndicatorComponent] Failed to load unread count: ${err}`)
        },
      })
    )
  }

  override applyStyles(): void {
    super.applyStyles()

    const config = this.config as MarriottPmsMessagesIndicatorWidget
    const envelopeIconStyle: Record<string, string | number> = {}
    const badgeStyle: Record<string, string | number> = {}
    const badgeTextStyle: Record<string, string | number> = {}

    if (config.chipColor) {
      badgeStyle['background-color'] = config.chipColor
    }

    if (config.textColor) {
      envelopeIconStyle['fill'] = config.textColor
      badgeTextStyle['color'] = config.textColor
    }

    this.setRule('.envelope-icon', envelopeIconStyle)
    this.setRule('.badge', badgeStyle)
    this.setRule('.badge-text', badgeTextStyle)
  }
}
